/* ==========================================================================
   OMNI Quiz Vol. 4 - Funnel 2 · GLP-1 Muscle
   Copy follows the Figma "SPs - Support Pages" GLP-1 frames; flow, branching
   and scoring follow omni-quiz-funnel.html (Scoring & Personalization v4).
   Option order matters: scoring in quiz-vol4-engine.js reads answer indices.
   ========================================================================== */
(function () {
  'use strict';

  var S = {
    single: 'Please select one',
    multi: 'Please select all that apply'
  };

  /* med: 0 Ozempic/Wegovy · 1 Zepbound/Mounjaro · 2 Compounded · 3 Considering · 4 Recently stopped */
  /* unanswered counts as shown, so the "N of M" total doesn't jump up after answering */
  var onMed = function (a) { return a.med == null || a.med <= 2; };

  window.OMNI_QUIZ_V4_FUNNELS = window.OMNI_QUIZ_V4_FUNNELS || {};

  window.OMNI_QUIZ_V4_FUNNELS.glp1 = {
    id: 'glp1',
    name: 'GLP-1 Muscle Protection Check',
    promo: 'OMNIQUIZ-GLP1',

    /* Clinicians' Choice card: set the number and the 3 photos by hand */
    frontrow: {
      count: '675',
      photos: [
        'https://assets.app.thefrontrowhealth.com/yulyi33mil8glzv4b7fhzs5ipnz2',
        'https://assets.app.thefrontrowhealth.com/rdpnv5i5g5jmw9nl1c2udq4l2szf',
        'https://assets.app.thefrontrowhealth.com/pa8nliuewz7t7g0dmxjawwf0kr5a'
      ]
    },
    landing: {
      heroImage: 'glp1Hero',
      heroImageMobile: 'glp1HeroMobile',
      title: 'The flabby look isn’t\nin your fault.',
      lead: 'Up to 40% of the weight lost on GLP-1 medications is lean muscle - and that’s what keeps your metabolism,\nstrength and shape.',
      bullets: ['Keep the muscle, lose the fat', 'Stop the ‘skinny-soft’ look', 'Protect your metabolism after the meds'],
      question: 'Check your muscle-loss risk:',
      genders: [['male', 'green'], ['female', 'blue']],
      press: ['Healthline', 'Men’s Health', 'Women’s Health']
    },

    steps: [
      { type: 'single', id: 'med', title: 'Which medication are you on?', sub: S.single,
        opts: ['Ozempic / Wegovy (semaglutide)', 'Zepbound / Mounjaro (tirzepatide)', 'Compounded GLP-1', 'Considering starting', 'Recently stopped'] },

      { type: 'single', id: 'duration', title: 'How long have you been on it?', sub: S.single, showIf: onMed,
        opts: ['Less than 1 month', '1-3 months', '3-6 months', '6+ months'] },

      { type: 'single', id: 'lost', title: 'How much weight have you lost so far?', sub: S.single,
        showIf: function (a) { return a.med == null || a.med <= 2 || a.med === 4; },
        opts: ['Under 5 kg / 10 lb', '5-10 kg / 10-20 lb', '10-20 kg / 20-45 lb', 'More than 20 kg / 45 lb'] },

      { type: 'single', id: 'plateau', title: 'Has your weight loss slowed down or plateaued recently?', sub: S.single, showIf: onMed,
        opts: ['Yes - the scale barely moves', 'A little', 'No, still losing steadily'],
        why: 'Plateaus on GLP-1 usually mean lost muscle has lowered your calorie burn. Rebuilding muscle is how you restart the loss.' },

      { type: 'multi', id: 'beforeglp', title: 'What did you try before GLP-1?', sub: S.multi,
        opts: ['Calorie counting / diets', 'Intermittent fasting', 'Cardio / gym plans', 'Personal trainer', 'This is my first serious attempt'],
        none: [4] },

      { type: 'single', id: 'childhood', title: 'Which best describes you growing up?', sub: 'Your history helps us find your metabolic set point',
        opts: ['I was always the bigger kid', 'My weight went up and down', 'I was lean until my 20s-30s', 'Weight was never an issue until recently'],
        why: 'People who carried extra weight early in life have a higher ‘set point’ the body defends. It’s not a life sentence - but it means muscle, the body’s biggest calorie burner, matters even more for you.' },

      { type: 'multi', id: 'changes', title: 'Have you noticed any of these changes?', sub: S.multi,
        opts: ['Softer / flatter muscles', 'Weaker in daily tasks or the gym', 'Constant fatigue', 'Feeling cold, low metabolism', 'Facial volume loss', 'None of these'],
        none: [5] },

      { type: 'single', id: 'protein', title: 'How much protein do you eat on a typical day?', sub: S.single,
        opts: ['I barely eat - appetite is gone', 'One real meal a day', 'Two meals, some protein', 'I hit my protein target daily'] },

      { type: 'single', id: 'hunger', title: 'How would you describe your hunger on the medication?', sub: S.single,
        opts: ['Gone - I sometimes forget to eat', 'Small - food doesn’t interest me much', 'Quiet all day, comes back in the evening', 'Fairly normal'],
        why: 'When hunger disappears, protein and creatine intake collapse with it - and the body starts pulling from muscle. That’s the gap your protocol has to cover.' },

      { type: 'single', id: 'train', title: 'How often do you do resistance training?', sub: S.single,
        opts: ['Never', '1-2× a week', '3+ times a week'] },

      { type: 'bodymap', id: 'areas', title: 'Where do you want to keep (or rebuild) muscle?', sub: 'Please tap all areas that apply' },

      { type: 'multi', id: 'symptoms', title: 'Any of these side effects?', sub: S.multi,
        opts: ['Nausea / low appetite', 'Brain fog', 'Low energy for workouts', 'Loose skin', 'None of the above'],
        none: [4] },

      { type: 'info', id: 'info1', title: 'We got you!', lead: 'Creatine is the most-studied supplement for preserving lean mass during weight loss.',
        image: 'infoPack',
        intro: 'OMNI Creatine Gummy was formulated for exactly this:',
        introLeft: true,
        bullets: ['Protect lean muscle while the scale drops', 'Keep strength & energy for resistance training', '3g creatine monohydrate, zero bloating, zero powders'],
        fine: '* Creatine combined with resistance training increases lean tissue mass vs. training alone (meta-analyses, Candow et al. 2022, 2024). Individual results vary.' },

      { type: 'single', id: 'event', title: 'Is there a moment you’d love to look your best for?', sub: S.single,
        opts: ['A vacation or trip', 'A wedding or big event', 'A reunion - seeing old friends', 'No event - I’m doing this for me'] },

      { type: 'single', id: 'pace', title: 'How fast would you like to see results?', sub: S.single,
        opts: ['As fast as possible', 'Steady and sustainable', 'No rush - I’m playing the long game'] },

      { type: 'single', id: 'age', title: 'What age group are you in?', sub: S.single,
        opts: ['18-24', '25-34', '35-44', '45-54', '55-64', '65+'] },

      { type: 'multi', id: 'hormones', title: 'Have you been through any of these hormonal changes?', sub: S.multi,
        showIf: function (a) { return a.gender === 'female'; },
        opts: ['Perimenopause or menopause', 'PCOS diagnosis', 'Thyroid condition', 'Pregnancy in the last 5 years', 'None of these'],
        none: [4],
        why: 'Falling estrogen accelerates muscle loss - one reason weight gets harder after 40. Creatine is one of the best-studied supports for maintaining muscle through this transition.' },

      { type: 'height', id: 'height', title: 'What’s your height?' },
      { type: 'weight', id: 'weight', title: 'What’s your current weight & goal?',
        note: 'Results are not guaranteed. Creatine stores typically saturate in 3-4 weeks with daily use; body-composition changes depend on training and diet.' },
      { type: 'loader', id: 'loader', title: 'Building your creatine protocol...',
        checks: ['Evaluating your answers...', 'Estimating your creatine stores...', 'Matching clinical dosing data...', 'Building your protocol...'] },
      { type: 'email', id: 'email', label: 'Your match is ready', title: 'One step left to see your protocol',
        text: 'We’ll also let you know when <b>OMNI free samples</b> are available.' }
    ],

    /* ---- personalised result pages (R1-R7) + checkout ---- */
    results: {
      audience: '9,300+ GLP-1 users',
      matchedTo: 'Matched to your medication.',
      chartTitle: 'Lean muscle projection on GLP-1',
      guide: 'Creatine on GLP-1',
      bonusGuide: 'Creatine for GLP-1',
      goalFallback: 'Keep muscle on GLP-1',
      driversWhat: 'draining your muscles',
      triedFallbackTitle: 'Why those didn’t stick - and why this will',
      tierSuffix: ' GLP-1',
      profileRow: function (a, label) {
        var m = label('med', a.med);
        return ['Medication', m ? m.replace(/\s*\(.*\)$/, '') : '-'];
      },
      goal: function (delta, fmt) {
        return delta > 0 ? 'protect your muscle while losing ' + fmt(delta) : 'protect your muscle on GLP-1';
      },
      reviews: [
        ['Melissa R., 44', 'Lost 38 lb on Wegovy and looked ‘deflated’. Added OMNI + 2 lifting days and the softness came back as shape.', 'On Wegovy · 6 months'],
        ['James T., 51', 'My doctor suggested creatine to keep muscle. Gummies were the only format I’d actually take daily.', 'On Zepbound'],
        ['Lauren B., 36', 'Energy for workouts came back within two weeks. Strength didn’t drop this time.', 'On compounded semaglutide']
      ]
    }
  };
})();
